<template>
  <div class="flex flex-col items-center p-3 sm:px-1 sm:py-0 xs:pt-0">
    <h2
      :class="[
        'mb-8 text-center font-flex-bold text-2xl font-bold',
        'sm:text-left sm:text-lg',
        'xs:-mx-5 xs:mb-5 xs:border-b xs:border-b-neutral-50 xs:px-5 xs:pb-4',
      ]"
    >
      Регистрация
    </h2>
    <RegistrationForm />
    <div
      v-if="!hideOAuth && !isSocialAuthEmpty"
      class="mt-6 w-full border-t border-neutral-100 pt-6 text-center"
    >
      Или с помощью аккаунта
      <SocialNetworkAuth class="mt-4 justify-center" />
    </div>
    <div class="mt-6 w-full border-t border-neutral-100 pt-6 text-center">
      <UiButton underline @click="clickLogin"> Войти в профиль </UiButton>
    </div>
    <span class="mt-8 text-sm">
      Регистрируясь и авторизуясь, вы подтверждаете, что ознакомлены и согласны
      с условиями
      <a
        class="select-none underline underline-offset-1"
        target="_blank"
        :href="getAbsoluteLink('/pages/oferta')"
      >
        Публичной оферты
      </a>
      и
      <a
        class="select-none underline underline-offset-1"
        target="_blank"
        :href="getAbsoluteLink('/pages/privacy')"
      >
        Политики конфиденциальности
      </a>
    </span>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  hideOAuth: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const { openLoginModal } = useAuthStore()
const { closeModal } = useModalStore()
const { getAbsoluteLink } = useLocationStore()
const { isSocialAuthEmpty } = storeToRefs(useLayoutStore())
const clickLogin = () => {
  closeModal('registrationModal')

  openLoginModal()
}
</script>
